import type { ReactNode } from 'react';

export const symbol_clock_arrow_up: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M129-276.06q-86-86.06-86-209T129.06-694q86.06-86 209-86T547-693.94q86 86.06 86 209T546.94-276q-86.06 86-209 86T129-276.06Zm375.5-42.25q68.5-68.31 68.5-166.5T504.69-651.5Q436.38-720 338.19-720T171.5-651.69Q103-583.38 103-485.19t68.31 166.69q68.31 68.5 166.5 68.5t166.69-68.31ZM368-489v-119q0-12.75-8.68-21.38-8.67-8.62-21.5-8.62-12.82 0-21.32 8.62-8.5 8.63-8.5 21.38v130q0 5.57 2 10.78 2 5.22 7 10.22l83 83q8.07 8 20.53 8 12.47 0 20.47-8.25 8-8.25 8-21T441-416l-73-73Zm-30 4Zm424-201-37 37q-9 9-21 9t-21-9q-9-9-9-21t9-21l87-87q9.27-9 21.64-9 12.36 0 21.36 9l87 87q9 8.8 9 20.9 0 12.1-9 21.1-9 9-21 9t-21-9l-36-36v495q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-496Z"
		/>
	</svg>
);
